import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import ReactPaginate from 'react-paginate'

import Fuse from 'fuse.js'

import Loader from '../shared/loader'
import PartnerCard from './partner-card'
// import Pagination from './pagination'
import NoResultsFound from './no-results-found'

import fuseGlobalOpts from '../../utils/fuse-global-options'

import './main.scss'

class Main extends Component {

  static BIG_DESKTOP = 1400
  static SMALL_DESKTOP = 970
  static TABLET = 720

  state = {
    itemsPerPage: 16,
    currentPage: 0,
    breakpointDivisor: 4,
    transformedResults: [],
    company: '',
    location: '',
    initLoad: true
  }

  constructor (props) {
    super(props)

    this.onResize = this.onResize.bind(this)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { company, location } = nextProps

    const newState = {}

    if (company !== prevState.company) {
      newState.company = company
      window.dataLayer.push({
        'event': 'industrySearched',
        'searchedWhat': company
      })
      if (window.ga) {
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Interactions',
          eventAction: 'industrySearched',
          eventLabel: company
        })
      }
    }
    if (location !== prevState.location) {
      newState.location = location
      window.dataLayer.push({
        'event': 'locationSearched',
        'searchedWhere': location
      })
      if (window.ga) {
        window.ga('send', {
          hitType: 'event',
          eventCategory: 'Interactions',
          eventAction: 'locationSearched',
          eventLabel: location
        })
      }
    }
    
    if (!nextProps.results || nextProps.results.length === 0) {
      newState.transformedResults = []
      return newState
    }

    let transformedResults

    if (nextProps.isURLExact === 'exact') {
      if (company === 'all') {
        transformedResults = nextProps.results
      } else {
        transformedResults = nextProps.results.filter(partner => {
          const { name, info } = partner
          const { category, services } = info
          
          return company === name ||
                company === category ||
                services.find(service => company === service)

        })
      }
    } else {
      if (company === 'all') {
        transformedResults = nextProps.results
      } else {
        const fuseOpts = Object.assign({}, fuseGlobalOpts, {
          keys: [
            'name',
            'info.category',
            'info.services'
          ]
        })
        const fuse = new Fuse(nextProps.results, fuseOpts)
        transformedResults = fuse.search(company)
      }
    }

    if (location !== 'anywhere') {
      transformedResults = transformedResults.filter(result => {
        const loc = location.toLowerCase()
        const city = result.info.city.toLowerCase()
        const country = result.info.country.toLowerCase()
        const addrress = result.info.address.toLowerCase()
        return loc === city ||
               loc === country ||
               loc === addrress
      })  
    }

    newState.transformedResults = transformedResults

    return newState

  }

  onResize () {
    const { innerWidth: w } = window
    let breakpointDivisor = 4
    if (w > Main.BIG_DESKTOP) {
      breakpointDivisor = 4
    } else if (w > Main.SMALL_DESKTOP && w < Main.BIG_DESKTOP) {
      breakpointDivisor = 3
    } else if (w > Main.TABLET && w < Main.SMALL_DESKTOP) {
      breakpointDivisor = 2
    } else {
      breakpointDivisor = 1
    }
    this.setState({ breakpointDivisor })
  }

  componentDidMount () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.onResize)
  }

  handlePageClick = data => {
    const { selected: page } = data
    const { company, location, history } = this.props
    if (!this.state.initLoad) {
      history.push(`/${company}/${location}/${page + 1}`)
    }
    this.setState({ initLoad: false })
  }

  render() {
    const { itemsPerPage, breakpointDivisor } = this.state
    const { pageNumber, company, location } = this.props
    
    let results = this.state.transformedResults
    const fragmentMain = this.props.partnersEmpty ?
      <Loader /> :
      <div>
        <div className="filter-overview">
            Showing <span>{results.length} {results.length === 1 ? 'result' : 'results'}</span> for <span>{company}</span> in <span>{location}</span>
        </div>
        <div className="cards-container">
            {results.length > 0 ?
              results.map((partner, i) => {
                if (i >= (pageNumber - 1) * itemsPerPage && i < pageNumber * itemsPerPage) {
                  return <PartnerCard 
                    key={i} 
                    index={breakpointDivisor === 1 ? 0 : i % breakpointDivisor} 
                    props={partner} />
                }
                return null
              }).filter(a => a) :
              <NoResultsFound />
            }
            {/* add a bunch more partnerCards to ensure flexbox always alligns correctly */}
            <div className="partner-card"></div>
            <div className="partner-card"></div>
            <div className="partner-card"></div>
        </div>
        <div className="paginate-container">
          <ReactPaginate
            initialPage={pageNumber-1}
            previousLabel=""
            nextLabel=""
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            pageCount={Math.ceil(results.length / itemsPerPage)} 
            onPageChange={this.handlePageClick} />
        </div>
      </div>
    
    return (
      <main className="app-main container">
        {fragmentMain}
      </main>
    )
  }
}

export default compose(
    withRouter,
    connect((state, props) => {
      return {
        results: state.firebase.data['companies'],
        company: props.match.params.what,
        location: props.match.params.where,
        pageNumber: parseInt(props.match.params.pageNumber, 10),
        isURLExact: props.match.params.exact
      }
    })
)(Main)


// WEBPACK FOOTER //
// ./src/components/main/index.jsx